import React, { useEffect } from "react";
import Link from "@material-ui/core/Link";
import { Theme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Container from "@material-ui/core/Container";
import IconButton from "@material-ui/core/IconButton";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { ReactComponent as Logo } from "../../../../assets/svg/dark_logo.svg";
import AccessControl from "../../../../components/AccessControl";
import FontIcon from "../../../../components/FontIcon";
import { useUpdateProfileConfig } from "../../../user/userAccount/modals/EditProfile/config";
import CartMenu from "../../../payment/components/CartMenu";
import { UserRole } from "../../../user/enums/UserRole";
import { useAuth } from "../../../auth/hooks/useAuth";
import { useWizard } from "../../../wizard/context";
import DashboardRightMenu from "../sidebars/DashboardRightMenu";
import HeaderMenu from "../navigation/HeaderMenu";
import { useApp } from "../../hooks/useApp";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    alignItems: "center",
  },
  header: {
    position: "fixed",
    top: 0,
    display: "flex",
    alignItems: "center",
    backgroundColor: "rgba(255, 255, 255)",
    boxShadow: "0 6px 25px 0 rgba(0, 0, 0, 0.11)",
  },
  toolbar: {
    padding: "0 24px",
  },
  logoLink: {
    lineHeight: 0,
    display: "inherit",
  },
  logoImage: {
    width: 144,
    [theme.breakpoints.down("sm")]: {
      width: 120,
      height: "auto",
      marginTop: theme.spacing(1),
    },
  },
  links: {
    marginLeft: theme.spacing(1),
    color: theme.palette.primary.contrastText,
  },
}));

const DashboardHeader = ({ showCart, hideHeaderItems }) => {
  const classes = useStyles();
  const matches = useMediaQuery((theme: Theme) => theme.breakpoints.up("md"));
  const updateProfileConfig = useUpdateProfileConfig();
  const {
    data: { isCountryDialogOpened },
    actions: { toggleAdminDrawer, setIsCountryDialogOpened },
  } = useApp();
  const { openWizard } = useWizard();

  const {
    user,
    profile,
    actions: { refetch },
  } = useAuth();

  const update = async () => {
    await refetch();
    await profile.refetch();
  };

  const openUpdateProfileModal = async () => {
    setIsCountryDialogOpened(true);
    const newBranchData = await openWizard({
      steps: [
        {
          titleConfig: {
            titleText: "Country field is empty",
          },
          content: "Please fill out the country field",
        },
      ],
      submitButtonText: "Update Profile",
      cancelButtonText: null,
    });

    if (newBranchData) {
      (await openWizard(updateProfileConfig)) && (await update());
    }
  };

  useEffect(() => {
    user?.role === UserRole.School &&
      !isCountryDialogOpened &&
      !profile?.data.data.school.country &&
      openUpdateProfileModal();
  }, []);

  return (
    <AppBar color="primary" position="relative" className={classes.header}>
      <Container disableGutters>
        <Toolbar className={classes.toolbar}>
          <AccessControl
            verified={false}
            allowedRoles={[UserRole.Owner, UserRole.Admin, UserRole.Support]}
          >
            <IconButton
              edge="start"
              style={{ marginRight: 16 }}
              onClick={toggleAdminDrawer}
            >
              <FontIcon name="menu" color="primary" />
            </IconButton>
          </AccessControl>
          <div className={classes.root}>
            <div>
              <Link href="/" className={classes.logoLink}>
                <Logo className={classes.logoImage} />
              </Link>
            </div>
            {matches && !hideHeaderItems && (
              <AccessControl verified={false}>
                <HeaderMenu />
              </AccessControl>
            )}
          </div>
          {showCart && (
            <AccessControl verified={false} allowedRoles={[4]}>
              <CartMenu />
            </AccessControl>
          )}
          <DashboardRightMenu />
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default React.memo(DashboardHeader);
